import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { getPaymentInfo, getUserInfo, RobotInfo, UserInfo } from '@mygpt/app';

import { PaymentInfo } from '../utils/interface';

interface PilotStoreInterface {
  userInfo?: UserInfo;
  robotInfo?: RobotInfo;
  paymentInfo?: PaymentInfo;
  setUserInfo: (userInfo?: UserInfo) => void;
  setRobotInfo: (robotInfo?: RobotInfo) => void;
  fetchUserInfo: () => Promise<UserInfo>;
  // getPaymentInfo: () => Promise<PaymentInfo>;
}
export const useGPTStore = create<PilotStoreInterface>()(
  immer((set) => ({
    userInfo: undefined,
    robotInfo: undefined,
    paymentInfo: undefined,
    setUserInfo: (userInfo?: UserInfo) => {
      set({ userInfo });
    },

    setRobotInfo: (robotInfo?: RobotInfo) => {
      set({ robotInfo });
    },

    fetchUserInfo: () =>
      new Promise<UserInfo>((resolve, reject) => {
        getUserInfo()
          .then((res) => {
            if (!res) return;
            set((state) => {
              state.userInfo = res.data;
            });
            resolve(res.data);
          })
          .catch(reject);
      }),
  }))
);
